import React, { Component } from 'react';

class Home extends Component {
  render() { 
    return ( 
       <div>
           <p className="esriHome">Welcome to Esri Authentication Service</p>
       </div>
   ); 
  } 
}

export default Home;